import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { navigate } from "gatsby"
import SEO from "@components/SEO"
import Report from "@components/ReportPage"
import "@styles/Components/report.scss"
import LocationWrapper from "../components/LocationWrapper"
import { customRoutes } from "@utils/customRoutes"

const ReportPage = ({ location, data: { seo, allSanityCity } }) => {
  let params = new URLSearchParams(location.search)
  const address = params.get("address")
  const placeType = params.get("type") || undefined
  const customSeo = {
    title: seo?.seo?.title || "Report",
    ...seo?.seo,
  }

  useEffect(() => {
    // Only attempt redirects for legacy URLs (no type param). Typed URLs already had routing decided.
    if (placeType) return

    let temporalParams = new URLSearchParams(location.search)
    const addressParam = temporalParams.get("address")
    if (!addressParam) return

    const segments = addressParam.split(", ")

    if (segments.length <= 2) {
      const place = segments[0]
      customRoutes.forEach(element => {
        if (element.place === place || element.route === place) {
          navigate(`/${element.route}`)
        }
      })
    }

    if (segments.length === 3) {
      const city = segments[0]
      const state = segments[1]

      allSanityCity.nodes.forEach(element => {
        if (element.state?.state === state && element.city === city) {
          navigate(`/${element.state?.slug?.current}/${element.slug?.current}`)
        }
      })
    }
  }, [])

  return (
    <LocationWrapper>
      <SEO seo={customSeo} />
      <Report address={address} placeType={placeType} />
    </LocationWrapper>
  )
}

export default ReportPage

export const query = graphql`
  query ReportPage {
    seo: sanityPagesSeo(slug: { current: { eq: "/report" } }) {
      seo {
        title
        keywords
        description
      }
    }

    allSanityCity {
      nodes {
        city
        oldUrl
        slug {
          current
        }
        state {
          state
          slug {
            current
          }
        }
      }
    }
  }
`
